const countriesToOptOutOfDefault: readonly string[] = [
	'ca',
	'at',
	'it',
	'be',
	'lv',
	'bg',
	'lt',
	'lu',
	'cy',
	'mt',
	'cz',
	'nl',
	'dk',
	'pl',
	'ee',
	'pt',
	'fi',
	'ro',
	'fr',
	'fx',
	'sk',
	'de',
	'si',
	'gr',
	'es',
	'hu',
	'se',
	'ie',
	'gb',
];

export const shouldOptInToMarketingEmailByDefault = (countryAbbreviation?: string | null): boolean => {
	if (!countryAbbreviation || countriesToOptOutOfDefault.includes(countryAbbreviation.toLowerCase())) {
		return false;
	}
	return true;
};
